import { defaultEnv } from './default.api';
import { APIConfig } from './types';

export const environment: APIConfig = {
  ...defaultEnv,
  production: false,
};
